import React, { Component } from "react";
import { Link } from "react-router-dom";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import styled from "styled-components";
import Alert from "sweetalert-react";
import moment from "moment";
import { Bold, WhiteButtonLink } from "../Styles";
import { Loader } from "../Shared";
import { getProfiles as getProfilesAction } from "../../redux/middleware/profile";
import { getProfiles, getProfilesError } from "../../redux/reducers/profile";

const Header = styled.div`
  width: 100%;
  float: left;
  padding: 20px 20px 10px;
  background-color: #f6f7f8;
  border-bottom: 1px solid #ccc;
  border-top-left-radius: 4px;
  border-top-right-radius: 4px;
`

const HeaderTitle = styled.div`
  float: left;
  margin: 0 0 7px;
  font-weight: 700;
  color: #39b54a;
  font-size: 24px;
  padding: 0;
`

const Icon = styled.button`
  color: #8290a2;
  border-color: #8290a2;
  text-align: center;
  float: right;
  border-radius: 7px;
  margin-left: 4px;
  margin-top: 5px;
  padding: 2px 7px 1px;
`;

const IconLink = Icon.withComponent(Link);

const Profile = ({profile, confirm}) =>
  <tr>
    <td style={{paddingTop: 15}}>
      <Bold>{profile.title}</Bold>
    </td>
    <td style={{paddingTop: 15}} className="hidden-xs">
      <i className="fa fa-calendar"></i> {moment(profile.updated_at).format('MM-DD-YYYY')}
    </td>
    <td style={{paddingTop: 15}}>{profile.status ? 'Active' : 'Not Active'}</td>
    <td>
      <div>
        <Icon className="btn_status" alt="trash" onClick={() => confirm(profile)}>
          <i className="fa fa-trash" />
        </Icon>
        <IconLink
          className="btn btn_status"
          alt="view"
          to={{
            pathname: `/dashboard/profiles/${profile.id}`,
            profile,
          }}
        >
          <i className="fa fa-search" />
        </IconLink>
      </div>
    </td>
  </tr>

const ProfileTable = ({profiles, confirm}) => {
  if (profiles.length <= 0) {
    return (
      <div style={{padding: 20, paddingTop: 100}}>
        You have no profiles set up.
        Click <Link to="/dashboard/profiles/new">here</Link> to create a profile!
      </div>
    )
  } else {
    return (
      <table cellSpacing="0" cellPadding="0" className="table">
        <thead>
          <tr>
            <th className="bdl_radius" width="30%">Title</th>
            <th width="15%" className="hidden-xs">Last Updated</th>
            <th width="1%">Status</th>
            <th width="10%" className="hidden-xs"></th>
            <th width="20%" className="visible-xs"></th>
          </tr>
        </thead>
        <tbody>
          {profiles.length && profiles.map((profile, index) =>
            <Profile key={index} profile={profile} confirm={confirm}/>)}
        </tbody>
      </table>
    )
  }
}

class Profiles extends Component {
  constructor(props) {
    super(props);
    this.state = { show: false };
  }

  confirm = (profile) => {
    this.setState({ show: true, profile });
  };

  remove = () => {
    this.props.remove(this.state.profile);
    this.setState({ show: false });
  };

  cancel = () => {
    this.setState({ show: false });
  };

  render() {
    const {
      resumePending,
      user: { profiles },
    } = this.props;
    return (
      <div className="TabbedPanelsContent">
        <Header>
          <HeaderTitle>Profiles</HeaderTitle>
          <WhiteButtonLink
            to="/dashboard/profiles/new"
            className="btn btn-primary btn_apply white_bg"
            style={{ float: "right" }}
          >
            New Profile
          </WhiteButtonLink>
        </Header>
        <ProfileTable
          profiles={this.props.history.location.profiles || profiles}
          confirm={this.confirm}
          remove={this.remove}
        />
        <Loader show={resumePending} fullScreen vwidth="60%" />
        <Alert
          show={this.state.show}
          title="Are you sure?"
          text="Once deleted, you will not be able to recover this profile!"
          type="warning"
          onConfirm={this.remove}
          onCancel={this.cancel}
          showCancelButton
          buttons
          dangerMode
        />
      </div>
    );
  }
}

export default Profiles;
